import { FETCH_QUERIES_NAME } from '@common/constants';
import { useQuery } from '@tanstack/react-query';
import { IApiBaseProps } from '@common/api.models';
import { isValidApiBaseProps } from '@common/api.services';
import { AxiosErrorResponse } from '@core/error.models';
import {
  getLoadingRemovalCertsChecklistsCountAsync,
  getLoadingRemovalCertsMobileActionUsageAsync,
} from './report.services';
import { IMobileActionUsage, IProjectLoadingRemovalCertChecklistCount } from './report.models';

export const useGetLoadingRemovalCertsChecklistsCountAsync = (enabled = true) => {
  return useQuery<IProjectLoadingRemovalCertChecklistCount[], AxiosErrorResponse>(
    [FETCH_QUERIES_NAME.LOADING_REMOVAL_CERT_CHECKLIST_COUNT],
    async () => {
      const result = await getLoadingRemovalCertsChecklistsCountAsync();

      return result.items || [];
    },
    {
      enabled,
    },
  );
};

export const useGetLoadingRemovalCertsMobileActionUsageAsync = (props: IApiBaseProps, enabled = true) => {
  return useQuery<IMobileActionUsage[], AxiosErrorResponse>(
    [FETCH_QUERIES_NAME.LOADING_REMOVAL_CERT_MOBILE_ACTION_USAGE, props.projectId],
    async () => {
      const result = await getLoadingRemovalCertsMobileActionUsageAsync(props);

      return result.items || [];
    },
    {
      enabled: enabled && isValidApiBaseProps(props),
    },
  );
};
